"use client"

import Link from "next/link"
import { useLanguage } from "@/lib/i18n/language-context"

export function Footer() {
  const { t } = useLanguage()

  return (
    <footer className="border-t border-border bg-muted/30 px-4 py-12 md:px-6">
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-center gap-4 text-center">
          <Link href="/" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary">
              <span className="text-lg font-bold text-primary-foreground">3B</span>
            </div>
            <span className="text-lg font-semibold">3BproductAI</span>
          </Link>
          <p className="text-sm text-muted-foreground">{t.footerTagline}</p>
          <p className="text-sm text-muted-foreground">{t.copyright}</p>
        </div>
      </div>
    </footer>
  )
}
